// components/Home/FeatureCarousel.jsx

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import features from "config/features";

export default function FeatureCarousel() {
  return (
    <MKBox py={10} px={3} textAlign="center">
      {/* Section Heading */}
      <MKTypography variant="h3" fontWeight="bold" mb={6}>
        What We Offer
      </MKTypography>

      {/* Swiper Carousel */}
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        autoplay={{ delay: 3000 }}
        pagination={{ clickable: true }}
        style={{ paddingBottom: "20px" }} // Leaves room for pagination dots
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {features.map((feature, index) => (
          <SwiperSlide key={index}>
            {/* Feature Card Container */}
            <MKBox
              p={4}
              m={2}
              borderRadius="xl"
              bgcolor="white"
              border="1px solid #e5eaf2"
              boxShadow="0 8px 24px rgba(0, 0, 0, 0.05)"
              textAlign="center"
              sx={{
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                },
              }}
            >
              {/* 🔍 Conditionally render SVG or JSX Icon */}
              {typeof feature.icon === "string" ? (
                // SVG icon
                <MKBox
                  component="img"
                  src={feature.icon}
                  alt={feature.title}
                  sx={{
                    width: 48,
                    height: 48,
                    mx: "auto",
                    mb: 2,
                    filter: "drop-shadow(0 0 8px #8a2be2)",
                  }}
                />
              ) : (
                // JSX (MUI) icon
                <MKBox
                  sx={{
                    width: 48,
                    height: 48,
                    mx: "auto",
                    mb: 2,
                    color: "primary.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "2.2rem", // Adjusts size of MUI icon
                  }}
                >
                  {feature.icon}
                </MKBox>
              )}

              {/* Title */}
              <MKTypography variant="h6" fontWeight="bold" mb={1}>
                {feature.title}
              </MKTypography>

              {/* Description */}
              <MKTypography variant="body2" sx={{ color: "text.secondary" }}>
                {feature.description}
              </MKTypography>
            </MKBox>
          </SwiperSlide>
        ))}
      </Swiper>
    </MKBox>
  );
}
